export default __webpack_public_path__ + "static/media/trailer-1-disney-mobile.0f9a0664.png";